import gql from 'graphql-tag';

const query = gql`
  query CookbookTags($dietTypeTags: [Int]) {
    cookbook {
      tags {
        mealTypeTags(dietTypeTags: $dietTypeTags) {
          id
          name
          imageUrl
          mealsCount
        }
      }
    }
  }
`;

export default query;
